import { reduce as _reduce, slice as _slice } from 'lodash'

const NEWS_STATS_AVGNUM = 24 // 24h

const movingAverage = (stats) => {
  return stats
    .map((el, index, array) => {
      const start = Math.max(0, index - NEWS_STATS_AVGNUM / 2)
      const end = Math.min(array.length, index + NEWS_STATS_AVGNUM / 2)
      return {
        date: new Date(el.publishDate),
        ton2: el.tonality2,
        ton3: el.tonality3,
        ton4: el.tonality4,
        arr: _slice(array, start, end),
      }
    })
    .map((stats) => {
      const { ton, num } = _reduce(
        stats.arr,
        (acc, p) => ({
          ton: acc.ton + p.tonality3 * 0.5 + p.tonality4,
          num: acc.num + p.tonality2 + p.tonality3 + p.tonality4,
        }),
        { ton: 0, num: 0 }
      )
      const time = new Date(stats.date)
      return {
        time: +time / 1000 - time.getTimezoneOffset() * 60,
        value: ton / num,
      }
    })
}

export default movingAverage
